import { withPrefix } from 'gatsby'
import React from 'react'
// import Img from 'gatsby-image'
import marked from 'marked'
import { FormattedMessage } from 'react-intl';
const { slugify } = require('../utils');


const BioDetail = ({ speaker, intervento }) => (
  <section id="bio-detail" className={`section bio-detail ${slugify(intervento.tipologia)}`} aria-labelledby="region1">
    <div className="container">
      <div className="row" data-aos="fade-up">
        <div className="col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2">
          <div className="row">
            <div className="col-sm-8 col-sm-push-4">
              <h1 id="region1" className="bio-detail__title">{speaker.jobtitle}</h1>
              <div className="bio-detail__bodytext" dangerouslySetInnerHTML={{__html: marked(speaker.bio)}}></div>
            </div>
            <div className="col-sm-4 col-sm-pull-8">
              <div className="bio-detail__person">
                <figure className="bio-detail__figure">
                  <img src={withPrefix(speaker.img)} alt={speaker.title} className="bio-detail__img" />
                  <span className="bio-detail__icon">
                    {!!speaker.workshop && <span className="workshop"></span>}
                    {!!speaker.casestudy && <span className="casestudy"></span>}
                    {!!speaker.presentazione && <span className="presentazione"></span>}
                    {!!speaker.esposizione && <span className="esposizione"></span>}
                    {!!speaker.keynote && <span className="keynote"></span>}
                  </span>
                </figure>
                <div className="bio-detail__program">
                  {!!speaker.workshop && <span className="workshop"><FormattedMessage id="workshop"/></span>}
                  {!!speaker.casestudy && <span className="casestudy"><FormattedMessage id="casestudy"/></span>}
                  {!!speaker.presentazione && <span className="presentazione"><FormattedMessage id="presentazione"/></span>}
                  {!!speaker.esposizione && <span className="esposizione"><FormattedMessage id="expo"/></span>}
                  {!!speaker.keynote && <span className="keynote"><FormattedMessage id="keynote"/></span>}
                </div>
                <span className="bio-detail__name">{speaker.title}</span>
                {!!(speaker.twitter || speaker.linkedin) && (
                  <div className="bio-detail__social">
                    {/* eslint-disable-next-line */}
                    {!!speaker.twitter && <a href={speaker.twitter} title="Twitter" className="">
                      <i className="fa fa-twitter" aria-hidden="true"></i>
                    </a>}
                    {/* eslint-disable-next-line */}
                    {!!speaker.linkedin && <a href={speaker.linkedin} title="LinkedIn" className="">
                      <i className="fa fa-linkedin-square" aria-hidden="true"></i>
                    </a>}
                  </div>
                )}
                {!!speaker.pubblicazioni && (
                  <div className="bio-detail__pub">
                    <div className="bio-detail__pubtitle"><FormattedMessage id="pubblicazioni"/></div>
                    <div dangerouslySetInnerHTML={{__html: marked(speaker.pubblicazioni)}}></div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
)

export default BioDetail
